/*
 * RYAuto core — Mi Carro by RepuestosYA
 * Núcleo compartido para "Mi Carro" y "Mi Reparación".
 * Sin dependencias, sin backend. Datos en el dispositivo (localStorage + IndexedDB).
 * Expone window.RYAuto. Ver MiCarro-PRD.md §7.
 */
(function () {
  'use strict';
  if (window.RYAuto) return; // evita doble carga

  var NS = 'ryauto:v1:';
  var KEYS = {
    vehicles: NS + 'vehicles',
    activeVehicle: NS + 'activeVehicleId',
    maintenance: NS + 'maintenance',
    parts: NS + 'parts',
    contacts: NS + 'contacts',
    repairs: NS + 'repairs',
    prefs: NS + 'prefs',
    meta: NS + 'meta'
  };

  /* ---------------------------------------------------------------- config */
  var defaults = {
    storeName: 'RepuestosYA',
    whatsappNumber: '50433899071',
    countryCode: '504',
    currencySymbol: 'L',
    searchUrl: '/search',
    appendVehicleToSearch: true,
    locale: 'es-HN',
    miCarroUrl: '/#mi-carro-app',
    reparacionUrl: '/#mi-reparacion-app'
  };
  var config = clone(defaults);

  function loadConfig() {
    // 1) objeto global opcional
    if (window.RYAutoConfig && typeof window.RYAutoConfig === 'object') {
      config = deepMerge(config, window.RYAutoConfig);
    }
    // 2) tags JSON inyectados por las secciones Liquid
    var tags = document.querySelectorAll('script[type="application/json"][data-ryauto-config]');
    for (var i = 0; i < tags.length; i++) {
      try {
        var parsed = JSON.parse(tags[i].textContent || '{}');
        config = deepMerge(config, parsed);
      } catch (e) { /* ignora config inválida */ }
    }
  }

  /* ----------------------------------------------------------------- utils */
  function clone(o) { return JSON.parse(JSON.stringify(o)); }

  function deepMerge(base, over) {
    var out = Array.isArray(base) ? base.slice() : Object.assign({}, base);
    if (!over || typeof over !== 'object') return out;
    Object.keys(over).forEach(function (k) {
      var v = over[k];
      if (v && typeof v === 'object' && !Array.isArray(v) && base && typeof base[k] === 'object') {
        out[k] = deepMerge(base[k], v);
      } else if (v !== null && v !== undefined && v !== '') {
        out[k] = v;
      }
    });
    return out;
  }

  function uid(prefix) {
    return (prefix || 'id') + '_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }

  function money(n) {
    var num = Number(n);
    if (!isFinite(num)) return '';
    try { return config.currencySymbol + ' ' + num.toLocaleString(config.locale); }
    catch (e) { return config.currencySymbol + ' ' + num; }
  }

  function fmtDate(d) {
    try {
      var date = d ? new Date(d) : new Date();
      return date.toLocaleDateString(config.locale, { day: '2-digit', month: 'short', year: 'numeric' });
    } catch (e) { return String(d || ''); }
  }

  function normPhone(raw) {
    var digits = String(raw || '').replace(/\D/g, '');
    if (!digits) return '';
    if (digits.indexOf('00') === 0) digits = digits.slice(2); // prefijo internacional 00 -> fuera
    // Honduras: número local de 8 dígitos -> anteponer código país
    if (digits.length === 8) digits = config.countryCode + digits;
    return digits;
  }

  /* --------------------------------------------------------------- storage */
  var lsOK = (function () {
    try { var k = NS + 't'; localStorage.setItem(k, '1'); localStorage.removeItem(k); return true; }
    catch (e) { return false; }
  })();
  var memStore = {}; // fallback en memoria (iOS privado / cuota)

  var store = {
    get: function (key, fallback) {
      try {
        var raw = lsOK ? localStorage.getItem(key) : memStore[key];
        if (raw == null) return fallback === undefined ? null : fallback;
        return JSON.parse(raw);
      } catch (e) { return fallback === undefined ? null : fallback; }
    },
    set: function (key, val) {
      var raw = JSON.stringify(val);
      try {
        if (lsOK) localStorage.setItem(key, raw); else memStore[key] = raw;
        return true;
      } catch (e) {
        memStore[key] = raw; // degradación
        ui.toast('No se pudo guardar todo en este teléfono (memoria llena o modo privado).', { type: 'warn' });
        return false;
      }
    },
    remove: function (key) { try { if (lsOK) localStorage.removeItem(key); else delete memStore[key]; } catch (e) {} }
  };

  function readArr(key) { var a = store.get(key, []); return Array.isArray(a) ? a : []; }
  function writeArr(key, arr) { return store.set(key, arr); }

  /* -------------------------------------------------------------- vehicles */
  var vehicles = {
    list: function () { return readArr(KEYS.vehicles); },
    get: function (id) { return vehicles.list().filter(function (v) { return v.id === id; })[0] || null; },
    create: function (data) {
      var v = Object.assign({
        id: uid('veh'), nickname: '', make: '', model: '', year: '', engine: '',
        mileage: '', city: '', use: '', plate: ''
      }, data || {});
      v.createdAt = Date.now(); v.updatedAt = Date.now();
      if (!v.nickname) v.nickname = ('Mi ' + (v.model || 'carro')).trim();
      var arr = vehicles.list(); arr.push(v); writeArr(KEYS.vehicles, arr);
      vehicles.setActive(v.id);
      emit('vehicle:change', v);
      return v;
    },
    update: function (id, patch) {
      var arr = vehicles.list(); var found = null;
      arr = arr.map(function (v) { if (v.id === id) { found = Object.assign(v, patch, { updatedAt: Date.now() }); return found; } return v; });
      writeArr(KEYS.vehicles, arr); emit('vehicle:change', found); return found;
    },
    remove: function (id) {
      writeArr(KEYS.vehicles, vehicles.list().filter(function (v) { return v.id !== id; }));
      if (store.get(KEYS.activeVehicle) === id) {
        var rest = vehicles.list(); vehicles.setActive(rest[0] ? rest[0].id : null);
      }
      emit('vehicle:change', null);
    },
    active: function () {
      var id = store.get(KEYS.activeVehicle);
      var v = id ? vehicles.get(id) : null;
      if (!v) { var all = vehicles.list(); v = all[0] || null; if (v) store.set(KEYS.activeVehicle, v.id); }
      return v;
    },
    setActive: function (id) { if (id) store.set(KEYS.activeVehicle, id); else store.remove(KEYS.activeVehicle); emit('vehicle:active', id); },
    format: function (v) {
      if (!v) return '';
      var s = [v.make, v.model, v.year].filter(Boolean).join(' ');
      if (v.engine) s += ' · ' + v.engine;
      return s.trim();
    },
    searchSuffix: function (v) {
      if (!v) return '';
      return [v.make, v.model, v.year].filter(Boolean).join(' ').trim();
    }
  };

  /* ----------------------------------------------------- maintenance/parts */
  var maintenance = {
    list: function (vehicleId) {
      var a = readArr(KEYS.maintenance);
      return vehicleId ? a.filter(function (m) { return m.vehicleId === vehicleId; }) : a;
    },
    add: function (rec) {
      var m = Object.assign({ id: uid('mnt'), createdAt: Date.now(), photoIds: [] }, rec || {});
      var arr = readArr(KEYS.maintenance); arr.unshift(m); writeArr(KEYS.maintenance, arr); return m;
    },
    remove: function (id) { writeArr(KEYS.maintenance, readArr(KEYS.maintenance).filter(function (m) { return m.id !== id; })); }
  };

  var parts = {
    list: function (vehicleId) {
      var a = readArr(KEYS.parts);
      return vehicleId ? a.filter(function (p) { return p.vehicleId === vehicleId; }) : a;
    },
    add: function (p) {
      var item = Object.assign({ id: uid('prt'), createdAt: Date.now() }, p || {});
      var arr = readArr(KEYS.parts); arr.unshift(item); writeArr(KEYS.parts, arr); return item;
    },
    remove: function (id) { writeArr(KEYS.parts, readArr(KEYS.parts).filter(function (p) { return p.id !== id; })); },
    touch: function (id) {
      writeArr(KEYS.parts, readArr(KEYS.parts).map(function (p) { if (p.id === id) p.lastBoughtAt = Date.now(); return p; }));
    }
  };

  var contacts = {
    get: function () { return store.get(KEYS.contacts, {}) || {}; },
    set: function (role, info) { var c = contacts.get(); c[role] = info; store.set(KEYS.contacts, c); return c; }
  };

  /* ------------------------------------------------------------- repairs */
  var STATUSES = ['diagnostico', 'buscando', 'comprado', 'en_reparacion', 'listo'];
  var repairs = {
    statuses: STATUSES,
    list: function (vehicleId) {
      var a = readArr(KEYS.repairs);
      a = vehicleId ? a.filter(function (r) { return r.vehicleId === vehicleId; }) : a;
      return a.sort(function (x, y) { return (y.updatedAt || 0) - (x.updatedAt || 0); });
    },
    get: function (id) { return readArr(KEYS.repairs).filter(function (r) { return r.id === id; })[0] || null; },
    create: function (data) {
      var r = Object.assign({
        id: uid('rep'), vehicleId: null, vehicleSnapshot: '', title: '', problem: '',
        status: 'diagnostico', requestedItems: [], photoIds: [], warranties: [], notes: '',
        history: []
      }, data || {});
      r.createdAt = Date.now(); r.updatedAt = Date.now();
      r.history.push({ status: r.status, at: Date.now() });
      var arr = readArr(KEYS.repairs); arr.unshift(r); writeArr(KEYS.repairs, arr);
      emit('repair:change', r); return r;
    },
    update: function (id, patch) {
      var found = null;
      writeArr(KEYS.repairs, readArr(KEYS.repairs).map(function (r) {
        if (r.id === id) { found = Object.assign(r, patch, { updatedAt: Date.now() }); return found; } return r;
      }));
      emit('repair:change', found); return found;
    },
    remove: function (id) {
      var rep = repairs.get(id);
      if (rep && rep.photoIds) rep.photoIds.forEach(function (pid) { photos.remove(pid); });
      writeArr(KEYS.repairs, readArr(KEYS.repairs).filter(function (r) { return r.id !== id; }));
      emit('repair:change', null);
    },
    setStatus: function (id, status) {
      if (STATUSES.indexOf(status) < 0) return null;
      var rep = repairs.get(id); if (!rep) return null;
      rep.history = rep.history || []; rep.history.push({ status: status, at: Date.now() });
      return repairs.update(id, { status: status, history: rep.history });
    },
    countOpen: function (vehicleId) {
      return repairs.list(vehicleId).filter(function (r) { return r.status !== 'listo'; }).length;
    }
  };

  /* --------------------------------------------------------- IndexedDB fotos */
  var DB_NAME = 'ryauto', DB_STORE = 'photos', dbPromise = null;
  var idbOK = ('indexedDB' in window);
  var objectUrls = [];

  function openDB() {
    if (!idbOK) return Promise.reject(new Error('no-idb'));
    if (dbPromise) return dbPromise;
    dbPromise = new Promise(function (resolve, reject) {
      var req = indexedDB.open(DB_NAME, 1);
      req.onupgradeneeded = function () {
        var db = req.result;
        if (!db.objectStoreNames.contains(DB_STORE)) db.createObjectStore(DB_STORE, { keyPath: 'id' });
      };
      req.onsuccess = function () { resolve(req.result); };
      req.onerror = function () { reject(req.error); };
    });
    return dbPromise;
  }

  function downscale(file, maxDim, quality) {
    maxDim = maxDim || 1280; quality = quality || 0.8;
    return new Promise(function (resolve) {
      if (!file || !/^image\//.test(file.type)) { resolve(file); return; }
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        try {
          var w = img.naturalWidth, h = img.naturalHeight;
          var scale = Math.min(1, maxDim / Math.max(w, h));
          var cw = Math.round(w * scale), ch = Math.round(h * scale);
          var canvas = document.createElement('canvas'); canvas.width = cw; canvas.height = ch;
          canvas.getContext('2d').drawImage(img, 0, 0, cw, ch);
          URL.revokeObjectURL(url);
          canvas.toBlob(function (blob) { resolve(blob || file); }, 'image/jpeg', quality);
        } catch (e) { URL.revokeObjectURL(url); resolve(file); }
      };
      img.onerror = function () { URL.revokeObjectURL(url); resolve(file); };
      img.src = url;
    });
  }

  var photos = {
    downscale: downscale,
    add: function (file) {
      return downscale(file).then(function (blob) {
        return openDB().then(function (db) {
          return new Promise(function (resolve, reject) {
            var id = uid('pho');
            var tx = db.transaction(DB_STORE, 'readwrite');
            tx.objectStore(DB_STORE).put({ id: id, blob: blob, createdAt: Date.now() });
            tx.oncomplete = function () { resolve(id); };
            tx.onerror = function () { reject(tx.error); };
          });
        });
      });
    },
    url: function (id) {
      return openDB().then(function (db) {
        return new Promise(function (resolve, reject) {
          var req = db.transaction(DB_STORE, 'readonly').objectStore(DB_STORE).get(id);
          req.onsuccess = function () {
            var rec = req.result;
            if (!rec) { resolve(''); return; }
            var u = URL.createObjectURL(rec.blob); objectUrls.push(u); resolve(u);
          };
          req.onerror = function () { reject(req.error); };
        });
      });
    },
    blob: function (id) {
      return openDB().then(function (db) {
        return new Promise(function (resolve, reject) {
          var req = db.transaction(DB_STORE, 'readonly').objectStore(DB_STORE).get(id);
          req.onsuccess = function () {
            var rec = req.result;
            resolve(rec && rec.blob ? rec.blob : null);
          };
          req.onerror = function () { reject(req.error); };
        });
      });
    },
    file: function (id, name) {
      return photos.blob(id).then(function (blob) {
        if (!blob) return null;
        try { return new File([blob], name || (id + '.jpg'), { type: blob.type || 'image/jpeg' }); }
        catch (e) { blob.name = name || (id + '.jpg'); return blob; }
      });
    },
    remove: function (id) {
      return openDB().then(function (db) {
        return new Promise(function (resolve) {
          var tx = db.transaction(DB_STORE, 'readwrite');
          tx.objectStore(DB_STORE).delete(id);
          tx.oncomplete = resolve; tx.onerror = resolve;
        });
      }).catch(function () {});
    }
  };
  window.addEventListener('pagehide', function () { objectUrls.forEach(function (u) { try { URL.revokeObjectURL(u); } catch (e) {} }); });

  /* ----------------------------------------------------- WhatsApp / salida */
  var wa = {
    text: function (lines) { return (Array.isArray(lines) ? lines : [lines]).filter(function (l) { return l != null; }).join('\n'); },
    url: function (number, text) {
      var n = normPhone(number || config.whatsappNumber);
      return 'https://wa.me/' + n + '?text=' + encodeURIComponent(text || '');
    },
    open: function (number, text) { window.open(wa.url(number, text), '_blank', 'noopener'); },
    openStore: function (text) { wa.open(config.whatsappNumber, text); }
  };

  var geo = {
    locate: function (opts) {
      return new Promise(function (resolve, reject) {
        if (!('geolocation' in navigator)) { reject(new Error('no-geo')); return; }
        navigator.geolocation.getCurrentPosition(function (pos) {
          var lat = pos.coords.latitude, lng = pos.coords.longitude;
          resolve({ lat: lat, lng: lng, accuracy: pos.coords.accuracy, mapsUrl: 'https://maps.google.com/?q=' + lat + ',' + lng });
        }, function (err) { reject(err); }, Object.assign({ enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }, opts || {}));
      });
    }
  };

  var clipboard = {
    copy: function (text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text).then(function () { return true; }).catch(function () { return legacyCopy(text); });
      }
      return Promise.resolve(legacyCopy(text));
    }
  };
  function legacyCopy(text) {
    try {
      var ta = document.createElement('textarea'); ta.value = text;
      ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.top = '-1000px';
      document.body.appendChild(ta); ta.select();
      var ok = document.execCommand('copy'); document.body.removeChild(ta); return ok;
    } catch (e) { return false; }
  }

  var share = {
    any: function (data) {
      if (navigator.share) {
        return navigator.share(data).then(function () { return true; }).catch(function () { return false; });
      }
      var txt = [data.title, data.text, data.url].filter(Boolean).join('\n');
      return clipboard.copy(txt).then(function (ok) { if (ok) ui.toast('Copiado para compartir.'); return ok; });
    }
  };

  var search = {
    url: function (query, vehicle) {
      var q = String(query || '');
      if (config.appendVehicleToSearch && vehicle) {
        var suffix = vehicles.searchSuffix(vehicle);
        if (suffix) q = q + ' ' + suffix;
      }
      return config.searchUrl + '?type=product&q=' + encodeURIComponent(q.trim());
    }
  };

  var print = {
    card: function (html, opts) {
      opts = opts || {};
      var iframe = document.createElement('iframe');
      iframe.setAttribute('aria-hidden', 'true');
      iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;';
      document.body.appendChild(iframe);
      var doc = iframe.contentWindow.document;
      doc.open();
      doc.write('<!doctype html><html><head><meta charset="utf-8"><title>' + escapeHtml(opts.title || 'RepuestosYA') + '</title>' +
        '<style>' +
        'body{font-family:Inter,Arial,sans-serif;color:#121212;margin:32px;line-height:1.5;}' +
        'h1{font-size:22px;margin:0 0 4px;} .muted{color:#666;} hr{border:0;border-top:1px solid #ddd;margin:18px 0;}' +
        'ul{padding-left:18px;} li{margin:4px 0;} .row{margin:6px 0;} .tag{display:inline-block;border:1px solid #121212;border-radius:6px;padding:2px 8px;font-size:12px;}' +
        '.foot{margin-top:24px;font-size:12px;color:#888;}' +
        '</style></head><body>' + html + '</body></html>');
      doc.close();
      var done = function () {
        try { iframe.contentWindow.focus(); iframe.contentWindow.print(); } catch (e) {}
        setTimeout(function () { if (iframe.parentNode) iframe.parentNode.removeChild(iframe); }, 1000);
      };
      if (iframe.contentWindow.document.readyState === 'complete') setTimeout(done, 200);
      else iframe.onload = function () { setTimeout(done, 200); };
    }
  };

  /* ----------------------------------------------------------- PWA-lite A2HS */
  var deferredPrompt = null;
  window.addEventListener('beforeinstallprompt', function (e) { e.preventDefault(); deferredPrompt = e; emit('a2hs:available'); });
  var a2hs = {
    platform: function () {
      var ua = navigator.userAgent || '';
      if (/iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) return 'ios';
      if (/Android/.test(ua)) return 'android';
      return 'desktop';
    },
    isStandalone: function () {
      return (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || window.navigator.standalone === true;
    },
    canPrompt: function () { return !!deferredPrompt; },
    prompt: function () {
      if (!deferredPrompt) return Promise.resolve(false);
      deferredPrompt.prompt();
      return deferredPrompt.userChoice.then(function (res) {
        deferredPrompt = null;
        var ok = res && res.outcome === 'accepted';
        if (ok) track('a2hs_installed', {});
        return ok;
      });
    },
    instructions: function (p) {
      p = p || a2hs.platform();
      if (p === 'ios') return 'En tu iPhone: tocá el botón Compartir (cuadro con flecha) y elegí “Agregar a inicio”.';
      if (p === 'android') return 'En tu teléfono: abrí el menú (⋮) de Chrome y elegí “Agregar a pantalla principal”.';
      return 'En tu navegador: abrí el menú e instalá / agregá esta página como acceso directo.';
    }
  };

  /* ----------------------------------------------------------- analítica */
  function track(name, payload) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, payload || {})); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, payload || {}); } catch (e) {}
  }

  /* --------------------------------------------------------------- pub/sub */
  var listeners = {};
  function on(evt, fn) { (listeners[evt] = listeners[evt] || []).push(fn); return function () { off(evt, fn); }; }
  function off(evt, fn) { if (listeners[evt]) listeners[evt] = listeners[evt].filter(function (f) { return f !== fn; }); }
  function emit(evt, payload) { (listeners[evt] || []).forEach(function (f) { try { f(payload); } catch (e) {} }); }

  /* -------------------------------------------------------------- UI helpers */
  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    attrs = attrs || {};
    Object.keys(attrs).forEach(function (k) {
      var v = attrs[k];
      if (v == null || v === false) return;
      if (k === 'class') node.className = v;
      else if (k === 'text') node.textContent = v;
      else if (k === 'html') node.innerHTML = v; // usar solo con contenido controlado/escapado
      else if (k === 'dataset') Object.keys(v).forEach(function (d) { node.dataset[d] = v[d]; });
      else if (k.slice(0, 2) === 'on' && typeof v === 'function') node.addEventListener(k.slice(2).toLowerCase(), v);
      else if (k === 'style' && typeof v === 'object') Object.assign(node.style, v);
      else node.setAttribute(k, v === true ? '' : v);
    });
    appendChildren(node, children);
    return node;
  }
  function appendChildren(node, children) {
    if (children == null) return;
    if (!Array.isArray(children)) children = [children];
    children.forEach(function (c) {
      if (c == null || c === false) return;
      if (typeof c === 'string' || typeof c === 'number') node.appendChild(document.createTextNode(String(c)));
      else node.appendChild(c);
    });
  }

  // Toasts
  var toastWrap = null;
  function ensureToastWrap() {
    if (toastWrap) return toastWrap;
    toastWrap = el('div', { class: 'rya-toasts', role: 'status', 'aria-live': 'polite' });
    document.body.appendChild(toastWrap);
    return toastWrap;
  }
  function toast(msg, opts) {
    opts = opts || {};
    var t = el('div', { class: 'rya-toast' + (opts.type ? ' rya-toast--' + opts.type : ''), text: msg });
    ensureToastWrap().appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    setTimeout(function () { t.classList.remove('is-in'); setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 250); }, opts.duration || 3200);
  }

  // Sheet / modal (bottom-sheet en móvil, diálogo en desktop)
  var openSheets = [];
  function sheet(opts) {
    opts = opts || {};
    var lastFocus = document.activeElement;
    var titleId = uid('sheet-title');

    var panel = el('div', { class: 'rya-sheet__panel', role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': titleId });
    var head = el('div', { class: 'rya-sheet__head' }, [
      el('h2', { class: 'rya-sheet__title', id: titleId, text: opts.title || '' }),
      el('button', { class: 'rya-sheet__close', type: 'button', 'aria-label': 'Cerrar', text: '✕', onclick: close })
    ]);
    var body = el('div', { class: 'rya-sheet__body' });
    if (typeof opts.content === 'string') body.innerHTML = opts.content;
    else if (opts.content) appendChildren(body, opts.content);

    panel.appendChild(head); panel.appendChild(body);
    if (opts.footer) { var foot = el('div', { class: 'rya-sheet__foot' }); appendChildren(foot, opts.footer); panel.appendChild(foot); }

    var backdrop = el('div', { class: 'rya-sheet' }, [panel]);
    backdrop.addEventListener('mousedown', function (e) { if (e.target === backdrop && opts.dismissible !== false) close(); });
    document.body.appendChild(backdrop);
    document.documentElement.classList.add('rya-noscroll');
    requestAnimationFrame(function () { backdrop.classList.add('is-open'); });

    var ctl = { el: panel, body: body, close: close };
    openSheets.push(ctl);

    function onKey(e) {
      if (openSheets[openSheets.length - 1] !== ctl) return; // solo la hoja superior reacciona
      if (e.key === 'Escape' && opts.dismissible !== false) { close(); return; }
      if (e.key === 'Tab') trapFocus(e, panel);
    }
    document.addEventListener('keydown', onKey);
    var focusables = panel.querySelectorAll('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])');
    setTimeout(function () { (opts.focus ? panel.querySelector(opts.focus) : focusables[0] || panel).focus(); }, 60);

    function close() {
      document.removeEventListener('keydown', onKey);
      backdrop.classList.remove('is-open');
      openSheets = openSheets.filter(function (s) { return s !== ctl; });
      if (!openSheets.length) document.documentElement.classList.remove('rya-noscroll');
      setTimeout(function () { if (backdrop.parentNode) backdrop.parentNode.removeChild(backdrop); }, 250);
      if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch (e) {}
      if (typeof opts.onClose === 'function') opts.onClose();
    }
    return ctl;
  }
  function trapFocus(e, panel) {
    var f = panel.querySelectorAll('button:not([disabled]),[href],input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  var ui = {
    el: el, append: appendChildren, escape: escapeHtml, money: money, date: fmtDate,
    toast: toast, sheet: sheet, on: on, off: off, emit: emit, track: track
  };

  /* ------------------------------------------------------------- ready/init */
  var readyQueue = [], isReady = false;
  function ready(fn) { if (isReady) fn(RYAuto); else readyQueue.push(fn); }
  function init() {
    loadConfig();
    isReady = true;
    readyQueue.forEach(function (fn) { try { fn(RYAuto); } catch (e) {} });
    readyQueue = [];
  }

  var RYAuto = {
    version: 1,
    get config() { return config; },
    ready: ready,
    store: store,
    vehicles: vehicles,
    maintenance: maintenance,
    parts: parts,
    contacts: contacts,
    repairs: repairs,
    photos: photos,
    wa: wa, geo: geo, share: share, clipboard: clipboard, search: search, print: print, a2hs: a2hs,
    ui: ui,
    track: track,
    util: { uid: uid, escapeHtml: escapeHtml, normPhone: normPhone, money: money, date: fmtDate, deepMerge: deepMerge }
  };
  window.RYAuto = RYAuto;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
